"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _SettingsHandler2 = require("./SettingsHandler");

var _SettingsHandler3 = _interopRequireDefault(_SettingsHandler2);

var _SettingsStore = require("../SettingsStore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets and sets settings at the "room-device" level for the current device in a particular
 * room.
 */
var RoomDeviceSettingsHandler = function (_SettingsHandler) {
    (0, _inherits3.default)(RoomDeviceSettingsHandler, _SettingsHandler);

    function RoomDeviceSettingsHandler(watchManager) {
        (0, _classCallCheck3.default)(this, RoomDeviceSettingsHandler);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RoomDeviceSettingsHandler.__proto__ || (0, _getPrototypeOf2.default)(RoomDeviceSettingsHandler)).call(this));

        _this._watchers = watchManager;
        return _this;
    }

    (0, _createClass3.default)(RoomDeviceSettingsHandler, [{
        key: "getValue",
        value: function getValue(settingName, roomId) {
            // Special case blacklist setting to use legacy values
            if (settingName === "blacklistUnverifiedDevices") {
                var _value = this._read("mx_local_settings");
                if (_value && _value['blacklistUnverifiedDevicesPerRoom']) {
                    return _value['blacklistUnverifiedDevicesPerRoom'][roomId];
                }
            }

            var value = this._read(this._getKey(settingName, roomId));
            if (value) return value.value;
            return null;
        }
    }, {
        key: "setValue",
        value: function setValue(settingName, roomId, newValue) {
            // Special case blacklist setting for legacy structure
            if (settingName === "blacklistUnverifiedDevices") {
                var value = this._read("mx_local_settings");
                if (!value) value = {};
                if (!value["blacklistUnverifiedDevicesPerRoom"]) value["blacklistUnverifiedDevicesPerRoom"] = {};
                value["blacklistUnverifiedDevicesPerRoom"][roomId] = newValue;
                localStorage.setItem("mx_local_settings", (0, _stringify2.default)(value));
                this._watchers.notifyUpdate(settingName, roomId, _SettingsStore.SettingLevel.ROOM_DEVICE, newValue);
                return _bluebird2.default.resolve();
            }

            if (newValue === null) {
                localStorage.removeItem(this._getKey(settingName, roomId));
            } else {
                newValue = (0, _stringify2.default)({ value: newValue });
                localStorage.setItem(this._getKey(settingName, roomId), newValue);
            }

            this._watchers.notifyUpdate(settingName, roomId, _SettingsStore.SettingLevel.ROOM_DEVICE, newValue);
            return _bluebird2.default.resolve();
        }
    }, {
        key: "canSetValue",
        value: function canSetValue(settingName, roomId) {
            return true; // It's their device, so they should be able to
        }
    }, {
        key: "isSupported",
        value: function isSupported() {
            return localStorage !== undefined && localStorage !== null;
        }
    }, {
        key: "_read",
        value: function _read(key) {
            var rawValue = localStorage.getItem(key);
            if (!rawValue) return null;
            return JSON.parse(rawValue);
        }
    }, {
        key: "_getKey",
        value: function _getKey(settingName, roomId) {
            return "mx_setting_" + settingName + "_" + roomId;
        }
    }]);
    return RoomDeviceSettingsHandler;
}(_SettingsHandler3.default); /*
                              Copyright 2017 Travis Ralston
                              Copyright 2019 New Vector Ltd.
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

exports.default = RoomDeviceSettingsHandler;
module.exports = exports["default"];
//# sourceMappingURL=RoomDeviceSettingsHandler.js.map